var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.886,
    height: 216.421,
    viewBox: "0 0 214.886 216.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359",
    transform: "translate(-399.347 -290.694)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_7afe8a380e0855e2e498f3a9fdd15df3",
    "data-name": "7afe8a380e0855e2e498f3a9fdd15df3",
    cx: 107.443,
    cy: 108.211,
    rx: 107.443,
    ry: 108.211,
    transform: "translate(399.347 290.694)",
    fill: "#8a94a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    transform: "translate(439.74 330.602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 40.675,
    cy: 39.907,
    rx: 40.675,
    ry: 39.907,
    transform: "translate(27.142 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersecci\\xF3n_4",
    "data-name": "Intersecci\\xF3n 4",
    d: "M68.25,64.786A90.466,90.466,0,0,1-.135,33.511V24a24,24,0,0,1,24-24h87.57a24,24,0,0,1,24,24V34.862A90.4,90.4,0,0,1,68.25,64.786Z",
    transform: "translate(0 94.929)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircle);
export default __webpack_public_path__ + "static/media/personCircle.df8993fec99117f30f86e94d5196a515.svg";
export { ForwardRef as ReactComponent };